var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRedCrossWithCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.75 0C18.2393 0 23.5 5.26065 23.5 11.75C23.5 18.2393 18.2393 23.5 11.75 23.5C5.26065 23.5 0 18.2393 0 11.75C0 5.26065 5.26065 0 11.75 0ZM11.75 1.5C6.08908 1.5 1.5 6.08908 1.5 11.75C1.5 17.4109 6.08908 22 11.75 22C17.4109 22 22 17.4109 22 11.75C22 6.08908 17.4109 1.5 11.75 1.5ZM15.2197 7.21973C15.5126 6.92683 15.9874 6.92683 16.2803 7.21973C16.5732 7.51262 16.5732 7.98738 16.2803 8.28027L12.8105 11.75L16.2803 15.2197C16.5732 15.5126 16.5732 15.9874 16.2803 16.2803C15.9874 16.5732 15.5126 16.5732 15.2197 16.2803L11.75 12.8105L8.28027 16.2803C7.98738 16.5732 7.51262 16.5732 7.21973 16.2803C6.92683 15.9874 6.92683 15.5126 7.21973 15.2197L10.6895 11.75L7.21973 8.28027C6.92683 7.98738 6.92683 7.51262 7.21973 7.21973C7.51262 6.92683 7.98738 6.92683 8.28027 7.21973L11.75 10.6895L15.2197 7.21973Z",
    fill: "#F25330"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedCrossWithCircle);
export default __webpack_public_path__ + "static/media/red-cross-with-circle.5942c769e4c17f35b2a27cdc944a24e0.svg";
export { ForwardRef as ReactComponent };